var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystemPromptStep = function SvgSystemPromptStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.598 1.264C2.969.892 3.474.684 4 .684h6a.65.65 0 0 1 .46.19l3.333 3.333a.65.65 0 0 1 .19.46v8.666A1.984 1.984 0 0 1 12 15.317H2.667a.65.65 0 1 1 0-1.3H12a.683.683 0 0 0 .683-.684v-7.35h-2.016A1.983 1.983 0 0 1 8.683 4V1.983H4a.683.683 0 0 0-.683.684v1.54a.65.65 0 1 1-1.3 0v-1.54c0-.526.209-1.03.58-1.403Zm7.385.972V4a.684.684 0 0 0 .684.683h1.764L9.983 2.236Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.853 6.056a.65.65 0 0 1 .858.33l.047.105a2.674 2.674 0 0 1 .718 0l.047-.105a.65.65 0 0 1 1.188.528l-.029.064c.22.161.413.354.573.573l.065-.028a.65.65 0 0 1 .527 1.188l-.104.046a2.673 2.673 0 0 1 0 .72l.105.046a.65.65 0 0 1-.529 1.188l-.064-.029c-.16.22-.354.413-.573.573l.029.064a.65.65 0 0 1-1.188.528l-.047-.104a2.664 2.664 0 0 1-.718 0l-.047.104a.65.65 0 0 1-1.188-.527l.029-.065a2.663 2.663 0 0 1-.573-.573l-.065.029a.65.65 0 0 1-.528-1.188l.105-.047a2.674 2.674 0 0 1 0-.719l-.105-.046a.65.65 0 1 1 .528-1.188l.064.028c.161-.219.355-.412.574-.573l-.029-.064a.65.65 0 0 1 .33-.858Zm1.264 1.71a1.35 1.35 0 1 0 0 2.7 1.35 1.35 0 0 0 0-2.7Z",
    clipRule: "evenodd"
  })));
};
export default SvgSystemPromptStep;